// Production/Development configuration
// These values are set via .env.production or .env.development
// To change for your server, edit client/.env.production

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL !== undefined ? process.env.REACT_APP_SOCKET_URL : 'http://localhost:5000';
export const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || '/socket.io';
export const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL || '/uploads';
